import { sync } from 'vuex-pathify';

export default {
  computed: {
    ...sync([
      'action/target', //
    ]),

    // facebookLink() {
    //   // console.log(this.data.profile.facebook);
    //   return this.$auth.user().admin ? `https://fb.com/${this.data.profile.facebook.id}` : '';
    // },
    facebookSearch() {
      // console.log(this.data.profile.facebook);
      return this.$auth.user().admin ? `https://www.facebook.com/search/top/?q=${this.data.profile.facebook.name}` : '';
    },
    // impersonateLink() {
    //   return this.$auth.user().admin ? `/admin/user/${this.data.profile.userId}/impersonate` : '';
    // },
    debugLink() {
      return this.$auth.user().admin ? `/admin/user/${this.data.profile.userId}/debug` : '';
    },
    profileLink() {
      return `/profile/${this.data.profile.id}`;
    },
  },

  methods: {
    adminAction(action) {
      console.log('admin-actions.run', action);

      this.target = this.data;
      Bus.$emit('modal:toggle', action);
    },

    impersonate() {
      this.$auth.impersonate({
        params: {
          mockid: this.data.id,
        },
      });
    },

    run(action) {
      // console.log(`running ${action}`);

      axios
        .post(`/api/admin/actions/${action}`)
        .then((response) => {
          // console.log('admin-actions.run', response);

          const event = {
            type: response.data.message,
            notification: response.data,
          };

          Bus.$emit('user:notify', event);
        });
    },
  },
};
